
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("l9Clz", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.6ccc6aec.js.map
